// extracted by mini-css-extract-plugin
export default {"categoryList":"category_categoryList__0lU0z","categoryImage":"category_categoryImage__vA4H-"};